import * as React from "react"
import type { SVGProps } from "react"
const SvgArrowDownRightCurved = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m17.18 12.14-2.9-2.9a1 1 0 0 1-.3-.7 1 1 0 0 1 .32-.7q.3-.27.7-.28t.7.28l4.6 4.6q.3.3.3.7t-.3.7l-4.6 4.6a1 1 0 0 1-.69.28q-.4 0-.71-.28a1 1 0 0 1-.3-.71q0-.42.3-.71l2.87-2.88H8a4.8 4.8 0 0 1-3.54-1.46A4.8 4.8 0 0 1 3 9.14v-3q0-.42.29-.71A1 1 0 0 1 4 5.14a.97.97 0 0 1 1 1v3q0 1.25.88 2.13a3 3 0 0 0 2.12.87z" />
  </svg>
)
export default SvgArrowDownRightCurved
